// extracted by mini-css-extract-plugin
export var checekd = "languageBar-module--checekd--fYNly";
export var form = "languageBar-module--form--HIBbL";
export var head = "languageBar-module--head--iJSQ9";
export var input = "languageBar-module--input--Jq6bv";
export var label = "languageBar-module--label--aY3yk";
export var languageBar = "languageBar-module--languageBar--KGAa-";